const utils = require('frontend-controller/lib/utils');

module.exports = {
	extends: [
		'/',
		'templates',
		'core',
		'table',
		'table'
	],

	config: {
		isSortable: true,
		supportLazyloading: false,
		buttonContext: 'offers',
		renderEmptyBeforReady: false,
		showHead: true,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: true,
		showDelimiterBorders: true,
		inline: true,
		preventSortOfField: {
		},
		rowActionsProperties: {
			colWidth: '40px',
		},
		rowActions: {
			customs: [
				{
					buttonType: 'download',
					icon: 'fi fi-download',
					inline: true,
					neutral: true,
				},
			]
		},

		heartbeatRefreshOn: {
			'reconnect': true,
			'resourceChanged.bo_offers': true,
		},
	},

	model: {},

	methods: {

		async download(rowID, rowData, buttonMode){
			if (((rowData || {}).attributes || {}).url) {
				window.open(`${rowData.attributes.url}.pdf`)
			}
		},

		async showEdit(rowID, rowData, buttonMode){
			if (((rowData || {}).attributes || {}).url) {
				window.open(rowData.attributes.url)
			}
		},

		onHeartbeat(message, heartbeatPrewarmedResourceHashes){
			const refreshers = this.config.heartbeatRefreshOn || {}
			const key = message.heartbeatKey
			const projectID = ((this.model.parentEntityForTable || {}).baseFilters || {}).projectID

			if(refreshers[key] && (
				(
					(
						key !== 'resourceChanged.bo_offers'
					) || (!projectID || message.data.projectID == projectID || (message.data.projectIDs || {})[projectID])
				)
			)){
				this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
			}
		},
	},
}
